let reloadChecked = false;

const wasPageReloaded = (): boolean => {
  if (reloadChecked) return false;
  reloadChecked = true;
  const entry = window?.performance?.getEntriesByType('navigation')?.[0];
  return (
    typeof PerformanceNavigationTiming !== 'undefined' &&
    entry instanceof PerformanceNavigationTiming &&
    entry.type === 'reload'
  );
};
export default wasPageReloaded;
